import React, { useContext, useState, useEffect, useRef } from "react";
import { ChatContext } from "../contexts/ChatContext";
import { LanguageContext } from "../contexts/LanguageContext";
import CustomDrawer from "../components/CustomDrawer";
import MessageItem from "../components/MessageItem";
import { ThemeContext } from "../contexts/ThemeContext";
import "../styles/ChatPage.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthContext } from "../contexts/AuthContext";
import { toast, ToastContainer } from "react-toastify";

const ChatPage = () => {
  const { messages, sendMessage, isLoading, currentChatId, startConversation } = useContext(ChatContext);
  const { translations, changeLanguage } = useContext(LanguageContext); // Dil çevirileri
  const { fetchQuotaInfo } = useContext(AuthContext); 
  const [quotaInfo, setQuotaInfo] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const { isDarkMode, toggleDarkMode } = useContext(ThemeContext); // ThemeContext kullanımı
  const messagesEndRef = useRef(null);


  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };



  useEffect(() => {
    const fetchQuota = async () => {
      const response = await fetchQuotaInfo();
      if (response.success) {
        setQuotaInfo(response.data);
      }
    };
    fetchQuota();
  }, [fetchQuotaInfo]);


  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleQuickMessage = (message) => {
    setNewMessage(message);
    handleSendMessage();
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;

    if (!currentChatId) {
      if (quotaInfo.current_quota <= 0) {
        toast.error(translations.jeton_uyari, {
          autoClose: 5000, 
        });
        return; 
      }
      try {
        const newConversation = await startConversation(newMessage.trim());
        if (newConversation?.conversation_id) {
          await sendMessage(newMessage.trim(), newConversation.conversation_id, newConversation.thread_id);
          setQuotaInfo((prev) => ({
            ...prev,
            current_quota: prev.current_quota - 1,
          }));
        }
      } catch (error) {
        console.error("Failed to start conversation and send message:", error);
      }
    } else {
      if (quotaInfo.current_quota <= 0) {
        toast.error(translations.jeton_uyari, {
          autoClose: 5000,
        });
        return; 
      }
    
      try {
        await sendMessage(newMessage.trim());
    
        setQuotaInfo((prev) => ({
          ...prev,
          current_quota: prev.current_quota - 1,
        }));
      } catch (error) {
        console.error("Failed to send message:", error);
      }
    }
    setNewMessage("");
  };

  return (
    <div className={`chat-page ${isDarkMode ? "dark-mode" : ""}`}>
    <CustomDrawer/>
    <div className={`container-fluid chat-container ${isDarkMode ? "dark-mode" : ""}`}>
      {/* Navbar */}
      <nav className={`navbar navbar-expand-lg ${isDarkMode ? "navbar-dark bg-dark" : "navbar-light bg-light"} rounded`}>
        <div className="container-fluid">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <i className="bi bi-coin me-2" style={{ fontSize: "1.5rem" }}></i>
            <span>{quotaInfo ? `${quotaInfo.current_quota}` : "Loading..."}</span>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="languageDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-translate"></i> {translations.language}
                </a>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
                  <li>
                    <button className="dropdown-item" onClick={() => changeLanguage("tr")}>
                      Türkçe
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => changeLanguage("en")}>
                      English
                    </button>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <button className="btn btn-dark ms-3" onClick={toggleDarkMode}>
                  {isDarkMode ? translations.lightMode : translations.darkMode}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  
      {/* Messages */}
      <div className="chat-messages">
        {messages.length === 0 ? (
          <div className="d-flex flex-column justify-content-center align-items-center vh-100 d-md-flex">
          <div className={`welcome-card card p-4 ${isDarkMode ? "bg-dark text-white" : "bg-light text-dark"} w-75 w-md-50 w-lg-25`}>
            <h2>{translations.welcomeTitle}</h2>
            <p>{translations.welcomeSubtitle}</p>
          </div>
        </div>
        ) : (
          messages.map((message, index) => (
            <div className="col-12" key={index}>
              <MessageItem
                message={message.message || message}
                isSentByUser={index % 2 === 0}
                isLastMessage={index === messages.length - 1}
              />
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
  
      {/* Quick Messages */}
      {messages.length === 0 && (
        <div className="row quick-messages">
          <button className="btn btn-primary col-12 col-md-4 mb-2" onClick={() => handleQuickMessage(translations.prompt_etf)}>
            {translations.prompt_etf}
          </button>
          <button className="btn btn-primary col-12 col-md-4 mb-2" onClick={() => handleQuickMessage(translations.prompt_etf_work)}>
            {translations.prompt_etf_work}
          </button>
        </div>
      )}
  
      {/* Input Section */}
      <div className="row chat-input align-items-center justify-content-center">
        <div className="col-12 col-lg-8 d-flex align-items-center gap-2">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder={translations.typeMessage}
            disabled={isLoading}
            className="form-control flex-grow-1"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSendMessage();
              }
            }}
          />
          <button
            onClick={handleSendMessage}
            disabled={isLoading || !newMessage.trim()}
            className="btn btn-primary d-flex align-items-center justify-content-center"
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </>
            ) : (
              <>
                <i className="bi bi-send-fill"></i>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
    <ToastContainer />
  </div>
  );
};

export default ChatPage;